import React from 'react';
import Loader from 'react-loader';
import { connect } from 'react-redux';
import LocalizedStrings from 'react-localization';
import CustomersClaims from '../../components/CustomersClaims/index.es6';
import * as actions from './actions.es6';
import * as globalActions from '../Main/actions.es6';
import { localisedText } from '../../lib/localisation.es6';
import { updateCurrentLanguage } from '../../lib/languageUtils.es6';

export class ClaimsClosed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      labels: new LocalizedStrings(localisedText),
    };
  }

  componentWillMount() {
    this.props.dispatch(actions.closedClaimsRequest());
    this.updateLanguage();
    this.props.dispatch(globalActions.hideCustomerBar());
  }

  componentDidUpdate() {
    this.updateLanguage();
  }

  updateLanguage() {
    updateCurrentLanguage(
      this.props.globalData.language,
      'ClaimsClosed',
      this.state.labels
    );
  }

  render() {
    const labels = this.state.labels;
    return (
      <Loader loaded={!this.props.claimData.loader} color="#ff834f">
        <CustomersClaims
          claims={this.props.claimData.closedClaimList}
          title={labels.closedClaims}
          columnWidth="col-md-12"
          showMore={false}
        />
      </Loader>
    );
  }
}

export default connect(state => ({
  claimData: state.closedClaimsList,
  globalData: state.global,
}))(ClaimsClosed);
